import { SplitioMultiValueTargetingRulesNamespace } from '../state/splitioMultiValueTargetingRules';
export enum SplitIOMultiValueTargettingRulesActionType {
    saveSplitIOMultiValueTargettingRules = 'saveSplitIOMultiValueTargettingRules',
}

export interface SaveSplitIOMultiValueTargettingRulesAction {
    type: SplitIOMultiValueTargettingRulesActionType.saveSplitIOMultiValueTargettingRules;
    payload: SplitioMultiValueTargetingRulesNamespace;
}

export const saveSplitIOMultiValueTargettingRulesAction = (
    featureflag: SplitioMultiValueTargetingRulesNamespace,
): SaveSplitIOMultiValueTargettingRulesAction => ({
    type: SplitIOMultiValueTargettingRulesActionType.saveSplitIOMultiValueTargettingRules,
    payload: featureflag,
});

export type SplitIOMultiValueTargettingRulesAction =
    SaveSplitIOMultiValueTargettingRulesAction;
